/**
 * Landing on a pass from a link — `/ds-repricing/executions?execution_id=…`,
 * the "See the pass in Executions" of Real time (CU-869fmm943, UX Obs. 12,
 * 13, 19). Read once when the list has loaded, then consumed.
 *
 *   in the 30 listed      → open it and highlight it;
 *   not there             → `{ fetch }`: ask for that pass alone;
 *   fetched on its own    → shown on top, open, with the note;
 *   the tenant has none   → "That pass could not be found."
 *
 * `fetched` is `undefined` before asking, `null` when the answer was empty.
 */
import { fmtSlot } from './slot.js'

export function arrivalOf(items, executionId, fetched) {
	if (!executionId) return null
	const listed = (items || []).find(r => r.execution_id === executionId)
	if (listed) return { openId: listed.id, prepend: null, note: null }
	if (fetched === undefined) return { fetch: executionId }
	if (!fetched) return { openId: null, prepend: null, note: 'That pass could not be found.' }
	return {
		openId: fetched.id, prepend: fetched,
		note: `The pass of ${fmtSlot(fetched.slot)} is older than the 30 listed here, so it is shown on its own, above them.`,
	}
}
